import React, { useState, useEffect, useRef } from "react";
import Styles from "./main.module.css";
import { CiSearch } from "react-icons/ci";
import { FaCheck, FaChevronDown } from "react-icons/fa";
import {
    searchCompaniesPublic,
} from "../../../Services/APIrequests";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";

const Home_content1 = () => {
    const [searchTerm, setSearchTerm] = useState("");
    // New state to hold search type selected by user
    const [searchType, setSearchType] = useState("name");
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const popupRef = useRef(null);
    const [apiStatus, setApiStatus] = useState(null); // track API status
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const navigate = useNavigate();



    // Function to determine if the search term is a CIN or name (you may keep for your own validation)
    const isCIN = (input) => /^[A-Z0-9]{11,21}$/i.test(input);



    const searchHandler = async () => {
        setError(null);
        setCompanies([]);

        if (searchTerm.trim().length < 1) {
            setShowPopup(false);
            return;
        }

        setShowPopup(true);
        setLoading(true);

        try {
            let queryKey = "";
            switch (searchType) {
                case "cin":
                    queryKey = "id";
                    break;
                case "llp":
                    queryKey = "id";
                    break;
                case "gst":
                    queryKey = "GSTNumber";
                    break;
                case "name":
                    queryKey = "name";
                    break;
                case "pan":
                    queryKey = "PanCard";
                    break;
                case "pf":
                    queryKey = "pfNumber";
                    break;
                case "din":
                    queryKey = "DIN";
                    break;
                default:
                    queryKey = "name";
            }

            // const query = `${queryKey}=${encodeURIComponent(searchTerm)}`;

            const response = await searchCompaniesPublic({
                [queryKey]: searchTerm,
            });
            // if (response.status === 200) {
            //   setCompanies(response.data.companies || []);
            // } else {
            //   setCompanies([]);
            // }
            if (response.status === 200) {
                setApiStatus(response.data.Status); // 👈 store API Status
                if (response.data.Status === 1) {
                    setCompanies(response.data.companies || []);
                } else if (response.data.Status === 2) {
                    setCompanies(
                        response.data.companies?.filter((item) => ({
                            cin: item.companyID,
                            companyName: item.companyName,
                        })) || []
                    );
                } else {
                    setCompanies([]);
                }
            } else {
                setCompanies([]);
            }
        } catch (err) {
            setError("Companies Not Found");
        } finally {
            setLoading(false);
            setShowPopup(true);
        }
    };

    // Debouncing search input
    useEffect(() => {
        const delay = setTimeout(() => {
            // ✅ Only call API if 3 or more characters
            if (searchTerm.trim().length >= 3) {
                searchHandler();
            } else {
                setCompanies([]);
                setShowPopup(false);
            }
        }, 1000); // ⏳ delay set to 2 seconds

        return () => clearTimeout(delay);
    }, [searchTerm, searchType]); // also trigger on searchType change

    // useEffect(() => {
    //   const debounceTimeout = setTimeout(() => {
    //     searchHandler();
    //   }, 500);

    //   return () => clearTimeout(debounceTimeout);
    // }, [searchTerm, searchType]);

    // Handle company click
    // const handleCompanyClick = (cin) => {
    //   const token = sessionStorage.getItem("token");
    //   if (token) {
    //     navigate(`/kohere/Companydetails/${cin}`);
    //   } else {
    //     navigate("/login");
    //   }
    // };

    // const handleCompanyClick = (cin) => {
    //   console.log("Navigating to:", `/kohere/Companydetails/${cin}`);
    //   navigate(`/kohere/Companydetails/${cin}`);
    // };

    const handleCompanyClick = (id, type = "CIN") => {
        navigate(`/kohere/Companydetails/${id}`, { state: { idType: type } });
    };

    // Close popup and dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowPopup(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const searchOptions = [
        { label: "Name", value: "name" },
        { label: "CIN/LLP/LLPIN", value: "cin" },
        { label: "GST", value: "gst" },
        { label: "PAN Card", value: "pan" },
        { label: "EPFO Number", value: "pf" },
        { label: "DIN", value: "din" },
    ];

    const getSearchTypeLabel = (val) => {
        const option = searchOptions.find(opt => opt.value === val);
        return option ? option.label : "Name";
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "name":
                return "Search by Company Name";
            case "cin":
                return "Search by CIN/LLP/LLPIN";
            case "gst":
                return "Search by GST";
            case "pan":
                return "Search by PAN Number";
            case "pf":
                return "Search by EPFO (PF) Number";
            case "din":
                return "Search by DIN Number";
            default:
                return "Search by Company / LLP / CIN / LLPIN";
        }
    };



    const inputRef = useRef(null);

    const handleBoxClick = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return (
        <div
            className={Styles.Home_search_main_container}
            data-aos="fade-up"
            data-aos-anchor-placement="center-bottom">
            <div className={Styles.Home_search_container1}>
                <div className={Styles.Home_search_slider}>
                    <div
                        className={Styles.Home_search_homebg}
                        style={{
                            backgroundColor: "hsl(220 82% 22%)",
                            filter: "none",
                        }}></div>
                </div>

                <div className={Styles.Home_search_overlay}>
                    <h1 className={Styles.Home_hero_title}>
                        One Platform for All Your <span className={Styles.Home_hero_title_highlight}>Business Compliance</span> Needs
                    </h1>
                    <p className={Styles.Home_hero_subtitle}>
                        From startup registration to GST, Income Tax & Trademark services — managed seamlessly.
                    </p>

                    <div className={Styles.Home_search_Container2}>
                        <h2 className={Styles.Home_search_Header}>
                            Comprehensive Data Access
                        </h2>
                        <div className={Styles.searchWrapper}>
                            <div className={Styles.customDropdown} ref={dropdownRef}>
                                <div
                                    className={Styles.dropdownTrigger}
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                >
                                    {getSearchTypeLabel(searchType)}
                                    <FaChevronDown className={Styles.chevronIcon} />
                                </div>
                                {isDropdownOpen && (
                                    <div className={Styles.dropdownMenu}>
                                        {searchOptions.map((option) => (
                                            <div
                                                key={option.value}
                                                className={`${Styles.dropdownItem} ${searchType === option.value ? Styles.activeItem : ""}`}
                                                onClick={() => {
                                                    setSearchType(option.value);
                                                    setIsDropdownOpen(false);
                                                }}
                                            >
                                                {searchType === option.value && (
                                                    <FaCheck className={Styles.checkIcon} />
                                                )}
                                                {option.label}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className={Styles.Home_Search_box} onClick={handleBoxClick}>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    placeholder={getPlaceholderText()}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    autoFocus
                                />
                                <CiSearch
                                    className={Styles["Home_Search_icon_search"]}
                                    size={22}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={Styles["Home_Search_companylist"]}>
                    {showPopup && (
                        <div className={Styles.searchcompanynames}>
                            <div
                                className={Styles.popup}
                                onClick={(event) => event.stopPropagation()}
                                ref={popupRef}>
                                <div className={Styles.popupContent}>
                                    {loading && (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                padding: "20px",
                                            }}>
                                            <RotatingLines
                                                height="40"
                                                width="40"
                                                strokeColor="#4fa94d"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                visible={true}
                                            />
                                        </div>
                                    )}
                                    {error && <p>{error}</p>}
                                    {!loading &&
                                        !error &&
                                        companies.length > 0 && (
                                            <>
                                                {apiStatus === 1 && (
                                                    <ul
                                                        className={
                                                            Styles.companyList
                                                        }>
                                                        {companies.map(
                                                            (
                                                                company,
                                                                index
                                                            ) => (
                                                                <li
                                                                    key={index}
                                                                    className={
                                                                        Styles.companyListItem
                                                                    }
                                                                    onClick={
                                                                        () =>
                                                                            handleCompanyClick(
                                                                                company?.CIN,
                                                                                "CIN"
                                                                            ) // 👈 CIN type
                                                                    }>
                                                                    {
                                                                        company?.CompanyName
                                                                    }
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                )}

                                                {apiStatus === 2 && (
                                                    <ul
                                                        className={
                                                            Styles.companyList
                                                        }>
                                                        {companies.map(
                                                            (
                                                                company,
                                                                index
                                                            ) => (
                                                                <li
                                                                    key={index}
                                                                    className={
                                                                        Styles.companyListItem
                                                                    }
                                                                    onClick={
                                                                        () =>
                                                                            handleCompanyClick(
                                                                                company.cin,
                                                                                "ID"
                                                                            ) // 👈 companyID type
                                                                    }>
                                                                    {
                                                                        company.entityName
                                                                    }
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                )}
                                            </>
                                        )}

                                    {!loading &&
                                        !error &&
                                        companies.length === 0 &&
                                        searchTerm.length >= 2 && (
                                            <p>No companies found</p>
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Home_content1;
